import { Typography } from '@acceso/design-system';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

type NoClipThumbnailProps = {
  className?: string;
  title?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  presenceImageUrl?: string;
};

export function NoClipThumbnail({
  className,
  title,
  style,
  onClick,
  presenceImageUrl,
}: NoClipThumbnailProps) {
  const { t } = useTranslation();
  return (
    <div
      className={clsx(
        'flex items-center justify-center',
        className ?? '',
        presenceImageUrl ? 'bg-white p-1' : 'bg-accent-disabled-20'
      )}
      title={title}
      style={style}
      onClick={onClick}
    >
      {presenceImageUrl ? (
        <img
          src={presenceImageUrl}
          alt={title}
          className="h-full w-full object-contain opacity-50"
        />
      ) : (
        <Typography className="select-none !text-body-1 font-medium text-text-dark-10">
          {t('No clip')}
        </Typography>
      )}
    </div>
  );
}
